module.exports = __webpack_public_path__ + "img/patient_profile.e4ca0eeb.svg";